module.exports = __webpack_public_path__ + "img/QOOKER_Box10.4961b58f.jpg";